import { request } from './request';

/**
 * 荣誉证书/知识产权项目
 */
export interface HonorItem {
  id: number;
  categoryId: number;
  title: string;
  url: string;
  label: string;
  publishTime: string;
  sortOrder: number;
  status: number;
}

/**
 * 获取荣誉证书/知识产权列表
 * @param categoryId - 分类ID：1-荣誉证书 2-知识产权
 */
export function getHonorQualifications(categoryId: number) {
  return request.get(`/honor_qualifications/${categoryId}`);
}
